import { ExportIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { IconButton, Typography } from '@global-engineering-shared/gweb-material-ui';

import { useFilters } from 'context/FilterProvider/FilterProvider';
import { usePaginatedItemsContext } from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { useSelectedEntitiesContext } from 'context/SelectedEntities/SelectedEntitiesProvider';
import useStyles from 'features/Drafts/components/ExportButton/ExportButton.styles';
import { useDownloadDataFile } from 'hooks/useDownloadFile';
import { DRAFTS_EXPORT_API_URL } from 'utils/defaults';
import { emptyFilters, toFiltersSearchParams } from 'utils/searchParamsConverter';
import { DraftStatusByTable } from 'utils/statuses';

export interface IExportButtonProps {
  status: DraftStatusByTable;
}

const ExportButton = ({ status }: IExportButtonProps) => {
  const classes = useStyles();

  const { selectedEntityIds, areEntitiesSelected } = useSelectedEntitiesContext();
  const { totalElements } = usePaginatedItemsContext();
  const { downloadFile } = useDownloadDataFile();
  const { filters } = useFilters();

  if (!areEntitiesSelected && !totalElements) return null;

  const downloadParams = areEntitiesSelected
    ? toFiltersSearchParams({ ...emptyFilters, spaceIds: selectedEntityIds() })
    : toFiltersSearchParams(filters);

  const handleDownloadClick = async () => {
    const url = `${DRAFTS_EXPORT_API_URL}/${status}?${downloadParams}`;
    await downloadFile(url, 'drafts.zip');
  };

  const buttonLabel = areEntitiesSelected ? 'Export Selected' : 'Export All';

  return (
    <IconButton className={classes.button} onClick={handleDownloadClick}>
      <ExportIcon color="primary" />
      <Typography variant="body2m" color="primary" className={classes.text}>
        {buttonLabel}
      </Typography>
    </IconButton>
  );
};
export default ExportButton;
